import { render } from "./LoaderTransactions.vue?vue&type=template&id=c1adadcc&scoped=true"
import script from "./LoaderTransactions.vue?vue&type=script&lang=js"
export * from "./LoaderTransactions.vue?vue&type=script&lang=js"

import "./LoaderTransactions.vue?vue&type=style&index=0&id=c1adadcc&scoped=true&lang=css"

import exportComponent from "D:\\work\\beam\\Project\\DAPPS\\beam-dapps\\nft_gallery_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1adadcc"]])

export default __exports__